import { z } from 'zod';

export const initiateImpersonationSchema = z.object({
  ssn: z.string().min(1),
  email: z.string().email(),
  targetTenantId: z.number(),
});

export type InitiateImpersonation = z.infer<typeof initiateImpersonationSchema>;
